import { $, $$ } from './_queryselector.js';
import * as _ from './_helpers.js';

export function init() {
    // get all the share buttons and attach a click event to them
    _.clickEvent('.js-share', (event) => {

        // stop the event bubbling up the DOM
        event.stopPropagation();
        // stop clicking the button from actually going to a URL
        event.preventDefault();

        // set the location of the popup window
        const winTop = (_.windowHeight / 2) - (_.windowHeight / 2);
        const winLeft = (_.windowWidth / 2) - (_.windowWidth / 2);


        // get the element in the page that holds all the data
        const data_object = $('.js-share-info');

        // assign the data to variables
        const url = encodeURIComponent(window.location.href);
        const title = data_object.getAttribute('data-title');

        // open a window based on which button was clicked
        if (event.target.classList.contains('-facebook')) {
            window.open('https://www.facebook.com/dialog/share' +
                '?app_id=430600850435986' +
                '&display=popup' +
                '&href=' + url +
                '&redirect_uri=' + url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=520,height=350');
        } else if (event.target.classList.contains('-twitter')) {
            window.open('https://twitter.com/intent/tweet?' +
                '&text=' + title +
                '&url=' + url + '&via=parallax', 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=520,height=350');
        } else if (event.target.classList.contains('-google')) {
            window.open('https://plus.google.com/share' +
            '?url=' + url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=520,height=350');
        } else if (event.target.classList.contains('-linkedin')) {
            window.open('https://www.linkedin.com/shareArticle?' +
            'mini=true' +
            '&url=' + url +
            '&title=' + title, 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=520,height=350');
        }
    });
}



// WEBPACK FOOTER //
// ./assets/js/components/_share.js